/* jslint browser: true */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';

import ProgramBlockTitle from './ProgramBlockTitle';
import AnnexeBlockTitle from './AnnexeBlockTitle';

/**
 * Titre du bloc
 */
class PageBlockTitle extends Component {

    constructor(props) {
        super(props);
    }

    render(){
        const block = this.props.block;
        return <div className={'block-title' + (block.semaine === 0 ? ' annexe-block-title' : ' program-block-title')}>
                {block.semaine === 0 ? <AnnexeBlockTitle titre={block.titre}></AnnexeBlockTitle> : <ProgramBlockTitle titre={block.titre}></ProgramBlockTitle>}
            </div>;
    }
}

PageBlockTitle.propTypes = { block: PropTypes.object };

export default PageBlockTitle;



// WEBPACK FOOTER //
// ./src/components/annexes/PageBlockTitle.js